import { render } from "./ReleaseCard.vue?vue&type=template&id=b8c2c886"
import script from "./ReleaseCard.vue?vue&type=script&lang=js"
export * from "./ReleaseCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ReleaseCard.vue?vue&type=style&index=0&id=b8c2c886&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__